import StatCard from "pages/dashboard-overview/components/StatCard";
import StatCardSkeleton from "pages/analytics/components/StatCardSkeleton";
import { formatCurrency } from "pages/analytics/components/analyticsFormatters";

export default function AttributionInsightsPanel({ insights, isLoading }) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {[...Array(3)].map((_, i) => (
          <StatCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  const { topSource, worstSource, highestRoiCampaign } = insights;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <StatCard
        title="Top Performing Source"
        value={topSource?.name ?? "-"}
        suffix={
          topSource ? ` · ${formatCurrency(topSource.attributedRevenue)}` : ""
        }
        icon="TrendingUp"
      />
      <StatCard
        title="Worst Performing Source"
        value={worstSource?.name ?? "-"}
        suffix={
          worstSource ? ` · ${formatCurrency(worstSource.attributedRevenue)}` : ""
        }
        icon="TrendingDown"
      />
      <StatCard
        title="Highest ROI Campaign"
        value={highestRoiCampaign?.campaign ?? "-"}
        suffix={
          highestRoiCampaign
            ? ` · ${formatCurrency(highestRoiCampaign.revenue)}`
            : ""
        }
        icon="Target"
      />
    </div>
  );
}
